<form
    name="form"
    (ngSubmit)="f.form.valid && processData()"
    #f="ngForm"
    novalidate
>
    <!-- Vedio Section -->
    <div class="form-group">
        <mat-form-field>
            <mat-select
                disableOptionCentering
                placeholder="Section"
                [(ngModel)]="selectedVedioSection"
                name="section"
                #section="ngModel"
                required
                (selectionChange)="onVideoSectionChange($event)"
            >
                <mat-option
                    [value]="vedioSectionList.value"
                >
                    {{ vedioSectionList.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <div
            [ngClass]="{
        'col-md-6': selectedVedioSection === 'PRODUCT_VIDEO'
      }"
            *ngIf="selectedVedioSection === 'PRODUCT_VIDEO'"
        >
            <div class="form-group padding-right-10">
                <!-- SCHEME: SECTION === PRODUCT VIDEO -->
                <mat-form-field>
                    <mat-select
                        disableOptionCentering
                        placeholder="Scheme"
                        [(ngModel)]="videoData.schemeCode"
                        name="Scheme"
                        #scheme="ngModel"
                        required
                    >
                        <mat-option
                            *ngFor="let scheme of schemeList"
                            [value]="scheme.schemeCode"
                        >
                            {{ scheme?.schemeName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div [ngClass]="{
        'col-md-6': selectedVedioSection === 'PRODUCT_VIDEO',
        'col-md-12': selectedVedioSection !== 'PRODUCT_VIDEO'
      }">
            <div class="form-group">
                <!-- Title -->
                <mat-form-field>
                    <input
                        matInput
                        placeholder="Title"
                        [(ngModel)]="videoData.videoName"
                        name="title"
                        #title="ngModel"
                        required
                    >
                </mat-form-field>
            </div>
        </div>
    </div>


    <!-- Youtube URL -->
    <div class="form-group">
        <mat-form-field>
            <input
                matInput
                placeholder="Youtube URL"
                [(ngModel)]="videoData.videoUrl"
                name="url"
                #url="ngModel"
                required
            >
        </mat-form-field>
    </div>
    <!-- Submit -->
    <div class="margin-top-20 text-center">
        <button
            mat-raised-button
            color="primary"
            class="mat-button-large"
            type="submit"
            [disabled]="!f.valid"
        >
            <span *ngIf="!videoData.id">Submit</span>
            <span *ngIf="videoData.id">Update</span>
        </button>
    </div>
</form>
